import React from 'react';
import { Modal, Typography, Button } from '@ann/web-components';
import { ModalHeader, ModalActions } from './Modal.styled';

const ConfirmModalBase = ({
    title,
    description,
    size = "medium",
    width = "900px",
    isOpen,
    onClose,
    onConfirm,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    isLoading = false
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size={size} width={width}>
            <Modal.Body>
                <ModalHeader>
                    <Typography
                        category="title"
                        size="medium"
                        weight="bold"
                        color="title"
                    >
                        {title}
                    </Typography>
                    {description && (
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                            color="body"
                        >
                            {description}
                        </Typography>
                    )}
                </ModalHeader>
                <ModalActions>
                    <Button
                        label={cancelLabel}
                        size="medium"
                        type="secondary"
                        onClick={onClose}
                        disabled={isLoading}
                    />
                    <Button
                        label={confirmLabel}
                        size="medium"
                        type="primary"
                        onClick={onConfirm}
                        isLoading={isLoading}
                    />
                </ModalActions>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmModalBase;

